import { Controller } from "@hotwired/stimulus"
import SignaturePad from "signature_pad"

export default class extends Controller {
  static targets = ["canvas", "input", "error", "checkbox", "submitButton"]

  connect() {
    this.signaturePad = new SignaturePad(this.canvasTarget, {
      backgroundColor: "rgb(255, 255, 255)",
      penColor: "rgb(0, 0, 0)"
    })

    this.signaturePad.addEventListener("endStroke", () => {
      this.updateSubmitButton()
    })

    this.resizeCanvas()
    window.addEventListener("resize", this.resizeCanvas.bind(this))
    this.updateSubmitButton()
  }

  toggleCheckbox() {
    this.updateSubmitButton()
  }

  updateSubmitButton() {
    if (this.hasSubmitButtonTarget && this.hasCheckboxTarget) {
      const isChecked = this.checkboxTarget.checked
      const hasSigned = !this.signaturePad.isEmpty()
      this.submitButtonTarget.disabled = !(isChecked && hasSigned)
    }
  }

  disconnect() {
    window.removeEventListener("resize", this.resizeCanvas.bind(this))
  }

  resizeCanvas() {
    const ratio = Math.max(window.devicePixelRatio || 1, 1)
    const canvas = this.canvasTarget
    const rect = canvas.getBoundingClientRect()

    canvas.width = rect.width * ratio
    canvas.height = rect.height * ratio
    canvas.getContext("2d").scale(ratio, ratio)

    this.signaturePad.clear()
  }

  clear() {
    this.signaturePad.clear()
    this.hideError()
    this.updateSubmitButton()
  }

  submit(event) {
    if (this.signaturePad.isEmpty()) {
      event.preventDefault()
      this.showError()
      return false
    }

    this.inputTarget.value = this.signaturePad.toDataURL()
    this.hideError()
    return true
  }

  showError() {
    if (this.hasErrorTarget) {
      this.errorTarget.classList.remove("d-none")
    }
  }

  hideError() {
    if (this.hasErrorTarget) {
      this.errorTarget.classList.add("d-none")
    }
  }
}
